import { jsx } from "react/jsx-runtime";
import React from "react";
import { MenuItem } from "@blueprintjs/core";
import tgUseLocalStorageState from "tg-use-local-storage-state";
const useShowChromQualScores = () => {
  return tgUseLocalStorageState("showChromQualScores", { defaultValue: true });
};
const ShowChromQualScoresMenu = () => function ShowChromQualScoresMenu2(props) {
  const [showChromQualScores, setShowChromQualScores] = useShowChromQualScores();
  return /* @__PURE__ */ jsx(
    MenuItem,
    {
      ...props,
      text: "Show Quality Scores",
      shouldDismissPopover: false,
      onClick: () => {
        setShowChromQualScores(!showChromQualScores);
      },
      icon: showChromQualScores ? "small-tick" : "blank"
    }
  );
};
const chromatogramMenu = {
  text: "Chromatogram (Quality Scores)",
  cmd: "showChromQualScoresMenu",
  component: ShowChromQualScoresMenu(),
  shouldDismissPopover: false
};
export { chromatogramMenu, useShowChromQualScores };
